<template>
  <v-container style="max-width: 1400px;">
    <div class="sensormonitoring-container" >

      <div class="monitoring-header flex s-bt">
        <h3>실시간 모니터링</h3>
        <div class="header-controls">
          <span class="clock">{{to_date}}</span>
          <v-btn class="refresh-btn" @click="refreshList()" :loading="loading">
            <v-icon color="white">mdi-refresh</v-icon>
          </v-btn>
        </div>
      </div>

      <div class="flex status-cards mt-3">
        <div class="status-card clickable" :class="{ active: showFarmList }" @click="toggleFarmList">
          <div class="total"></div>
          <div class="card-contents">
            <div class="card-icon">✉️</div>
            <div class="card-value">{{ status.seted.cnt }}개소</div>
            <div class="card-label">SMS 이용농가</div>
          </div>

          <div class="farm-bubble" v-if="showFarmList" style="display: block;">
            <div class="bubble-header">
                <span>🏡</span>
                <span>이용 사업장 목록</span>
            </div>
            <ul class="farm-list">
              <li v-for="(farm, index) in status.seted.farms" :key="index" class="farm-item">
                <div class="farm-icon">🌱</div>
                <span>{{ farm }}</span>
              </li>
            </ul>
        </div>
      </div>

        <div class="status-card">
          <div class="total"></div>

          <div class="card-contents">
            <div class="card-icon">💰</div>
            <div class="card-value">{{ status.remain?.won  }} 원</div>
            <div class="card-label">잔여 요금</div>
          </div>
        </div>

        <div class="status-card">
          <div class="total"></div>

          <div class="card-contents" @click="selectOption = 'day'" style="cursor: pointer;">
            <div class="card-icon">⏱️</div>
            <div class="card-value">{{ status.today.farm  }}개소 / {{ status.today.sms }}건 </div>
            <div class="card-label">당일 문자</div>
          </div>
        </div>

        <div class="status-card">
          <div class="total"></div>

          <div class="card-contents" @click="selectOption = 'week'" style="cursor: pointer;">
            <div class="card-icon">📊</div>
            <div class="card-value">{{ status.week.farm  }}개소 / {{ status.week.sms }}건</div>
            <div class="card-label">주간 발송</div>
          </div>
        </div>

        <div class="status-card">
          <div class="total"></div>

          <div class="card-contents" @click="selectOption = 'month'" style="cursor: pointer;">
            <div class="card-icon">🗓️</div>
            <div class="card-value">{{ status.month.farm  }}개소 / {{ status.month.sms }}건</div>
            <div class="card-label">월간 발송</div>
          </div>
        </div>

      </div>
    </div>

    <div class="detailnode-container">
      <div class="monitoring-header table-header">
        <div class="flex s-bt">
          <h3>문자 상세 현황</h3>

          <v-text-field
            dense
            style="max-width:12rem !important;"
            v-model="search"
            placeholder="발송일시나 사업장명을 검색하세요."
            outlined
            hide-details
            clearable
          ></v-text-field>
        </div>
        <div class="btn-container">
          <button
            v-for="option in filterOptions"
            :key="option.value"
            :class="{ active: selectOption === option.value }"
            @click="selectOption = option.value"
          >
            {{ option.label }}
          </button>
        </div>
       
      </div>

      <div class="table">
        <v-data-table
          height="100vh"
          :loading="loading" 
          :headers="headers"
          :items="filteredItems"
          :search="search"
          :items-per-page= "100000"
          class="custom-table"
          no-data-text="자료가 없거나 접근 권한이 없습니다."
          fixed-header
          hide-default-footer
          sort-by="date"
          :sort-desc="[true]"
          group-by="farm_cd"
          show-group-by
        >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="7" class="group-th">
            <v-icon @click="toggle">{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon> {{ items[0].farm_name }}
          </th>
        </template>
 
        <template v-slot:item.receiver="{ item }">
          <td>
            <div class="firm-mac" v-show="item.receiver !== '' ">
              {{ getPhoneMask(item.receiver) }}
            </div>
          </td>

        </template>

        <template v-slot:item.type="{ item }">
          <td >
            <div v-show="item.type !== '' ">
              {{ getTextType(item.type) }}
            </div>
          </td>

        </template>

      
        </v-data-table>
      </div>
    </div>

  </v-container>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
import Common from "@/utils/custom/common.js";

export default {
  name: 'listNode',
  computed: {
    filteredItems() {
      const now = new Date();

      const parseDate = (str) => new Date(str.replace(" ", "T"));
      //날짜비교 (당일 비교)
      const sameDate = (a, b) =>
        a.getFullYear() === b.getFullYear() &&
        a.getMonth() === b.getMonth() &&
        a.getDate() === b.getDate();

      return this.items.filter(item => {
        const itemDate = parseDate(item.date);

        switch (this.selectOption) {
          //전체
          case '':
            return true;
          //당일
          case 'day':
            return sameDate(itemDate, now);

          //어제
          case 'yesterday': {
            const yesterday = new Date(now);
            yesterday.setDate(now.getDate() - 1);
            yesterday.setHours(0, 0, 0, 0);

            const end = new Date(yesterday);
            end.setDate(yesterday.getDate() + 1); // 다음 날 0시

            return itemDate >= yesterday && itemDate < end;
          }

          //주간
          case 'week': {
            const start = new Date(now);
            start.setDate(now.getDate() - now.getDay()); // 일요일 기준 0:0:0:0
            start.setHours(0, 0, 0, 0);

            const end = new Date(start);
            end.setDate(start.getDate() + 7);

            return itemDate >= start && itemDate < end;
          }

          //월간
          case 'month':
            return (
              itemDate.getFullYear() === now.getFullYear() &&
              itemDate.getMonth() === now.getMonth()
            );
          default:
            return true;
        }
      });
    },
  },  
  data: () => ({
    items : [],
    status:{ 
      today:{}, week:{}, month:{},
      seted: { cnt: 0, farms: [] }},

    headers: [
      // { text: '사업장명', value: 'farm_name', groupable: true },
      { text: '발송일시', value: 'date', groupable: false  },
      { text: '수신번호', value: 'receiver', groupable: false },
      { text: '전송타입', value: 'type', groupable: false},
      { text: '전송내용', value: 'message', width:'550px', groupable: false},
    ],
    selectOption: '', 
    filterOptions: [
      { label: '전체', value: '' },
      { label: '당일', value: 'day' },
      { label: '어제', value: 'yesterday' },
      { label: '주간', value: 'week' },
      { label: '월간', value: 'month' },
    ],
    
    search: '',
    loading:false,

    showFarmList: false,


    to_date:'',

  }),
  async created() {
    Apis.pageCount({
      page_name: this.$route.name,
      url: this.$route.path,
      division: "pigro",
    },() => {  // 정상처리
      // console.log("pageCount 호출",res);
    }).catch( (err) => {  // 개별 API 오류 처리 예제
      console.log("pageCount 호출 오류",err);
    });
    this.summary();

    // await this.refreshList();
 },

  methods: {
    toggleFarmList() {
      this.showFarmList = !this.showFarmList;
    },
    refreshList() {
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.loading = true;
    

      Apis.monitorSMS({
        "detail" : true,
      } ,(res) => { 
        this.items = res.data;

        let cdate = new Date();
        this.to_date = dateUtil.format(cdate, "yyyy-MM-dd HH:mm:ss");

        this.loading = false;
      }).catch( (err) => {  
        console.log("monitorSensorNodes 호출 오류",err);
      }) 
    }, 
    summary(){
      this.refreshList();

      Apis.monitorSMS({
        "detail" : false,
      } ,(res) => { 
        this.status = res.data;
      }).catch( (err) => {  
        console.log("monitorSensorNodes 호출 오류",err);
      }) 
    },
    getPhoneMask(val){
      return Common.getMask(val)
    },
    getTextType(val){
      if(val == 'LMS'){
        return '장문'
      }else{
        return '단문'
      }
    }
 
  }  // -----------methods 

}
</script>

<style lang="scss">
@import '../../style/base.scss';
.table{
  height:50vh;
}
.custom-table {
  .v-data-table__wrapper {
    max-height: 50vh;
    overflow-y: auto;
  }
  
  .v-data-table-header {
    position: sticky !important;
    top: 0 !important;
    z-index: 10 !important;
    background-color: white !important;
  }
}
.custom-table {
  .v-data-table-header th {
    background-color: #f1f5f9 !important;
    font-weight: 600 !important;
  }

  .group-th {
    height:35px !important;
    background-color: #ececec;
  }
}

.sensormonitoring-container{
  background: white;
  padding: 1.0rem;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 0.3rem;
  border: 1px solid #e2e8f0;
}

.clock{
  font-size: 0.875rem;
  color: #64748b;
  background: #f1f5f9;
  font-size:1.1rem;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}
.monitoring-header {
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
}
.header-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}
.refresh-btn {
  background-color: #3c4c61 !important;
  padding: 15px;
  border-radius: 8px;
}
.status-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1rem;
}
.status-card {
  background: white;
  border-radius: 10px;
  /* padding: 1.25rem; */
  border: 1px solid #e2e8f0;
  text-align: center;
}
.card-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 0.25rem;
  line-height: 1;
}

.card-label {
  font-size: 0.875rem;
  color: #64748b;
  font-weight: 500;
}
.status-card > .total {
  height:5px;
  background-color: #64748b;
  border-radius: 10px 10px 0 0;
}
.card-contents{
  padding:1.25rem;
}
.card-icon{
  font-size:2.0rem;
}
.status-card > .normal {
  height:5px;
  background-color: #10b981;
  border-radius: 10px 10px 0 0;
}

.status-card > .error {
  height:5px;
  background-color: #ef4444;
  border-radius: 10px 10px 0 0;
}

.detailnode-container{
  background: #f1f5f9;
  border: 1px solid #d1d5db;

  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
}
.table-header{
  padding:1.2rem;
  border-bottom: 1px solid #d1d5db;;
}
.status-time{
  width:120px;
  letter-spacing: -0.75px;
  text-align: center;
}
.chip-info{
  width:150px;
  height:30px;
  align-items: center;
  justify-content: center;
  border-radius: 10px !important;
}
.status-dot {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  margin-right: 3px;
}
.back-green{
  background: #15803d !important;
}
.back-red{
  background: #dc2626 !important;
}
.chip-green{
  background: #dcfce7 !important;
  color: #15803d !important;
  border: 1px solid #bbf7d0 !important;
}
.chip-red{
  background: #fef2f2 !important;
  color: #dc2626 !important;
  border: 1px solid #fecaca !important;
}
.sensor-mac , .firm-mac{
  background: #f1f5f9;
  width:75%;
  text-align: center;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.75rem;
  color: #475569;
  border: 1px solid #e2e8f0;
}
.firm-mac{
  background-color: #f9fcff;
}
.clickable{
  cursor: pointer;
  transition : 0.2s ease;
}
.clickable:hover{
  box-shadow: 0 12px 32px rgba(0,0,0,0.1);
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}
.farm-bubble {
  position: absolute;
  left: 50%;
  transform: translateX(-230%);
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 280px;
  max-width: 320px;
  overflow: hidden;
}

.bubble-header {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 700;
  color: #374151;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.farm-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 240px;
  overflow-y: auto;
}

.farm-item {
  padding: 10px;
  font-size: 0.9rem;
  color: #374151;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.farm-item:last-child {
  border-bottom: none;
}

.farm-icon {
  width: 30px;
  height: 30px;
  background: #e2e8f0;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: white;
  font-weight: 600;
}
.btn-container button{
  padding:3px !important;
  width:60px !important;
  font-size:12px;
  border-radius: 5px;
  border: 1px solid #e2e8f0;
  margin-right:5px;
  transition: 0.2s ease ;
}
button.active {
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  color: black;
}
@media screen and (max-width: 1500px) {
  .table{
    height:45vh;
  }
  .custom-table {
    .v-data-table__wrapper {
      max-height: 45vh;
      overflow-y: auto;
    }
  }
}
</style>